export default {
	"4ca1cd68d79c56f0d72ad2e4cc4f3476": "适用于",
	"dcd9d382aa0f58e928873c76e917ebeb": "赠课",
	"baa57d150eefb7707e7557bfb939707b": "赠品",
	"89d77943b4c04ee218cb23c721c52254": "实物",
	"705f3627acdd1ed5403129cac4705f9b": "好友卡",
	"51c07086aeb9ff99a953b899e44054a9": "限时送好友一个月课程"
}
